import $axios from "@/common/http"  //导入封装的axios
// 查询接口
export const getSubject = (data:any) => {
    return $axios.get("/examSubject/list",{params:data});
};

export const getCerttype = () => {
    return $axios.get("/certificateType/selectList");
  };
// 预约考试科目列表
export function getApplyList(data:any){
    return $axios.get("/sysapplyexam/list",{params:data})
}

//　添加预约接口
export function addApply(data:any,roomId:any,examId:any,token:any){
    return $axios.post("/sysapplyexam/save",data,{params:{roomId,examId},headers:{token}})
}
// 修改接口
export function delApply(examId:any,token:any){
    return $axios.post("/sysapplyexam/update",{},{params:{applyStatus:0,examId},headers:{token}})
}
//　查询详情信息的接口
export function selectApplyInfo(token:any){
    return $axios.get("/sysapplyexam/info",{headers:{token}})
}

export function checkPwd(examRoomId:any,examPwd:any,token:any){
    return $axios.post("/sysapplyexam/checkPwd",{},{params:{examRoomId,examPwd},headers:{token}})
}

export function checkExamCondition(data:any,token:any){
    return $axios.get("/sysapplyexam/checkExamCondition",{params:{examId:data}, headers:{token}})
}
export function getExamSubject(data:any,token:any){
    return $axios.get("/examSubject/selectCertifiSubject",{params:{data}})
}
export function activitySchedulingSelectTrainingList(page:any=1,limit:any=5){
    return  $axios.get("/trainingActivities/selectTrainingList",{params:{pageIndex:page,pageSize:limit}})
}
export function uosCourseList(page:any=1,limit:any=5){
    return  $axios.get("/sysoauthintroduceinfo/list",{params:{displayed:1,pageIndex:page,pageSize:limit}})
}